import React from "react";
import LoaderHome from "../Loader-home/Loader-home";

const Loader = () => {
  return (
    // <div className="lds-dual-ring"></div>
    <>
      <LoaderHome />
      <LoaderHome />
      <LoaderHome />
    </>
  );
};

export default Loader;
